import { Dossier, DossierStats, ApiResponse, WorkflowAssignment, ModificationHistory } from '../types';
import api from './config';

export const dossierApi = {
  getAll: async (params?: {
    page?: number;
    conservation?: string;
    etat?: string;
    gestionnaire?: number;
  }): Promise<ApiResponse<Dossier>> => {
    const response = await api.get('/api/dossiers/', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Dossier> => {
    const response = await api.get(`/api/dossiers/${id}/`);
    return response.data;
  },

  create: async (data: Partial<Dossier>): Promise<Dossier> => {
    const response = await api.post('/api/dossiers/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Dossier>): Promise<Dossier> => {
    const response = await api.patch(`/api/dossiers/${id}/`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/dossiers/${id}/`);
  },

  getStats: async (): Promise<DossierStats> => {
    const response = await api.get('/api/dossiers/stats/');
    return response.data;
  },

  getMesDossiers: async (): Promise<Dossier[]> => {
    const response = await api.get('/api/dossiers/mes_dossiers/');
    return response.data;
  },

  // Workflow assignment methods
  addWorkflowAssignment: async (dossierId: number, assignment: Partial<WorkflowAssignment>): Promise<WorkflowAssignment> => {
    const response = await api.post(`/api/dossiers/${dossierId}/add_workflow_assignment/`, assignment);
    return response.data;
  },

  removeWorkflowAssignment: async (dossierId: number, assignmentId: number): Promise<void> => {
    await api.delete(`/api/dossiers/${dossierId}/remove_workflow_assignment/?assignment_id=${assignmentId}`);
  },

  updateWorkflowAssignment: async (dossierId: number, assignmentId: number, data: Partial<WorkflowAssignment>): Promise<WorkflowAssignment> => {
    const response = await api.patch(`/api/workflow-assignments/${assignmentId}/`, data);
    return response.data;
  },
  setModificationState: async (dossierId: number, etatDossier: string): Promise<any> => {
    const response = await api.post(`/api/dossiers/${dossierId}/set_modification_state/`, {
      etat_dossier: etatDossier
    });
    return response.data;
  },
  addModificationRequest: async (dossierId: number, data: {
  workflow_assignment_id: number;
  observations: string;
}): Promise<ModificationHistory> => {
  const response = await api.post(`/api/dossiers/${dossierId}/add_modification_request/`, data);
  return response.data;
},

startModification: async (dossierId: number, data: {
  modification_id: number;
  date_started?: string;
}): Promise<ModificationHistory> => {
  const response = await api.post(`/api/dossiers/${dossierId}/start_modification/`, data);
  return response.data;
},

completeModification: async (dossierId: number, data: {
  modification_id: number;
  date_completed: string;
  observations?: string;
}): Promise<ModificationHistory> => {
  const response = await api.post(`/api/dossiers/${dossierId}/complete_modification/`, data);
  return response.data;
},

resumeValidation: async (dossierId: number): Promise<any> => {
  const response = await api.post(`/api/dossiers/${dossierId}/resume_validation/`);
  return response.data;
},
};